export default [
  {
    path: "/phonelog/phone-page",
    name: "phone-page",
    component: () => import("@/views/pages/PhonePage/PhonePage.vue"),
    props: true,
    meta: {
      pageTitle: "電訪紀錄總覽",
      breadcrumb: [
        {
          text: "總表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/Dashboard",
    name: "Dashboard",
    component: () => import("@/views/pages/Dashboard.vue"),
    props: true,

    meta: {
      pageTitle: "Dashboard",
      breadcrumb: [
        {
          text: "總覽",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ProtocolUse",
    name: "ProtocolUse",
    component: () => import("@/views/pages/ProtocolUse/ProtocolUse.vue"),
    props: true,

    meta: {
      pageTitle: "協議動用正本追蹤",
      breadcrumb: [
        {
          text: "總表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/UnfundedUpdateSchedule",
    name: "UnfundedUpdateSchedule",
    component: () =>
      import("@/views/pages/Unfunded/UnfundedUpdateSchedule.vue"),
    props: true,

    meta: {
      pageTitle: "判定風險等級",
      breadcrumb: [
        {
          text: "未入動用追蹤",
          active: true,
        },
      ],
    },
  },
  {
    path: "/UnfundedRisk",
    name: "UnfundedRisk",
    component: () => import("@/views/pages/Unfunded/UnfundedRisk.vue"),
    props: true,

    meta: {
      pageTitle: "風險案件回報",
      breadcrumb: [
        {
          text: "未入動用追蹤",
          active: true,
        },
      ],
    },
  },
  {
    path: "/UnfundedLegalProcess",
    name: "UnfundedLegalProcess",
    component: () => import("@/views/pages/Unfunded/UnfundedLegalProcess.vue"),
    props: true,

    meta: {
      pageTitle: "法務處理",
      breadcrumb: [
        {
          text: "未入動用追蹤",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ServiceFeeTrack",
    name: "ServiceFeeTrack",
    component: () => import("@/views/pages/ServiceFeeTrack.vue"),
    props: true,

    meta: {
      pageTitle: "服務費追蹤",
      breadcrumb: [
        {
          text: "總表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/CaseTracking",
    name: "CaseTracking",
    component: () => import("@/views/pages/CaseTracking/CaseTracking.vue"),
    props: true,

    meta: {
      pageTitle: "案件追蹤盤點",
      breadcrumb: [
        {
          text: "總表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/ScheduleSetting",
    name: "ScheduleSetting",
    component: () =>
      import("@/views/pages/ScheduleSetting/ScheduleSetting.vue"),
    props: true,

    meta: {
      pageTitle: "排程設定",
      breadcrumb: [
        {
          text: "總表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/AutoZipLog",
    name: "AutoZipLog",
    component: () => import("@/views/pages/AutoZipLog/AutoZipLog.vue"),
    props: true,
    meta: {
      pageTitle: "自動化傳輸檔案加密設定",
      breadcrumb: [
        {
          text: "總表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/LogAnalyzerAlert",
    name: "LogAnalyzerAlert",
    component: () =>
      import("@/views/pages/LogAnalyzerAlert/LogAnalyzerAlert.vue"),
    props: true,
    meta: {
      pageTitle: "主機收出款異常通知紀錄",
      breadcrumb: [
        {
          text: "總表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/TaishinChequeSMS",
    name: "TaishinChequeSMS",
    component: () =>
      import(
        "@/views/pages/Systems/Dashboard/TaishinChequeSMS/TaishinChequeSMS.vue"
      ),
    props: true,
    meta: {
      pageTitle: "台新支票檔簡訊發送",
      breadcrumb: [
        {
          text: "總表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/BuyerLegalCorporation",
    name: "BuyerLegalCorporation",
    component: () =>
      import("@/views/pages/BuyerLegalCorporation/BuyerLegalCorporation.vue"),
    props: true,
    meta: {
      pageTitle: "檢查買方為法人",
      breadcrumb: [
        {
          text: "總表",
          active: true,
        },
      ],
    },
  },
  {
    path: "/CheckLoanBank",
    name: "CheckLoanBank",
    component: () => import("@/views/pages/CheckLoanBank/CheckLoanBank.vue"),
    props: true,
    meta: {
      pageTitle: "特殊貸款銀行檢查",
      breadcrumb: [
        {
          text: "總表",
          active: true,
        },
      ],
    },
  },
];
